import React from "react";
import Form from "./resetPasswordForm";
import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import backgroundImage from "../../images/wall.png";
import backgroundImg from "../../images/groupImg.png";

export default ({ forgotPassword }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      className="backGroundDiv"
      alignItems={["center", "center", "center", "flex-start"]}
      style={{
        backgroundImage: `url(${
          isLargeScreen ? backgroundImg : backgroundImage
        })`,
        backgroundSize: "100% auto",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Form
        forgotPassword={forgotPassword}
        isMediumScreen={isMediumScreen}
        isLargeScreen={isLargeScreen}
      />
    </Box>
  );
};
